import {RuntimeValue} from "./RuntimeValue";
import {RuntimeValueType} from "./RuntimeValueType";

export class RuntimeBoolean implements RuntimeValue {
	readonly type: RuntimeValueType = "boolean";
	readonly value: boolean;
	
	constructor(value: boolean) {
		this.value = value;
	}
	
	asString(): string {
		return this.value ? "true" : "false";
	}
	
	asBoolean(): boolean {
		return this.value;
	}
	
	asNumber(): number {
		return this.value ? 1 : 0;
	}
}
